<template>
    <mySubPage>
        <div slot="header">
            <myNav>{{$t('add_dep')}}</myNav>
            <div class="sn-info-box">
                <el-row>
                    <el-col :span="12">
                        {{$t('cname')}}{{$t('x_mh')}}<span class="f-blue">{{mod_cname}}</span>
                    </el-col>
                </el-row>
            </div>
        </div>
        <el-form class="pd-10" ref="form" :model="formData" label-width="120px">
            <el-form-item :label="$t('select_dep')">
                <el-checkbox-group v-model="formData.cats">
                    <el-checkbox v-for="item in cats" :key="item.key" :label="item.key">{{item.value}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
        </el-form>
        <div slot="footer">
            <div class="flex-box bg-f8">
                <div class="flex-box-bd"></div>
                <el-button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</el-button>
                <el-button type="primary" @click="submit">{{$t('save')}}</el-button>
            </div>
        </div>
    </mySubPage>
</template>

<script>
    export default {
        components: {
        },
        data:function(){
            return{
                relist: false,
                formData: {
                    mod_id: '',
                    cats: [],
                },
                mod_cname: '',
                cats: [],
            }
        },
        computed: {
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            var para = this.$base.getRequest();
            this.formData.mod_id = para.id;
            this.mod_cname = para.mod_cname;
            this.getInfo();
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getInfo: function(){
                const mod_id = this.formData.mod_id;
                this.$base.showLoading();
                this.$request.sendPost("mod/before-add-dep",{mod_id},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.cats = data.cats;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.$base.showLoading();
                this.$request.sendPost("mod/add-dep",this.formData,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.$base.msgSuccess(error.errmsg);
                        this.relist = true;
                        this.$base.linkBack();
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        },
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/system/mod_dep.vue